export class CAIPError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "CAIPError";
  }
}

export class CAIPValidationError extends CAIPError {
  constructor(
    message: string,
    public readonly invalidValue: string,
  ) {
    super(message);
    this.name = "CAIPValidationError";
  }
}

export class CAIPParseError extends CAIPError {
  constructor(
    message: string,
    public readonly invalidInput: string,
  ) {
    super(message);
    this.name = "CAIPParseError";
  }
}
